import { useState, useRef, useEffect } from 'react';
import { searchGuest } from '../utils/helperFunctions';

const NamesearchDropdown = ({ formData, formErrors, handleChange, handleSuggestionClick, namesuggestions, nameloading,setnameSuggestions,namequery,setnameLoading}) => {
    // const dropdownRef = useRef(null);
    const namesuggestionsRef = useRef(null);
    const [isNameInputFocused, setIsNameInputFocused] = useState(false);   
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const handleKeyDown = (e) => {
        // console.log(e.key);
        
        if (!isNameInputFocused || namesuggestions.length === 0) return;
        e.stopPropagation();
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const newIndex = selectedIndex < namesuggestions.length - 1 ? selectedIndex + 1 : selectedIndex;
            setSelectedIndex(newIndex);
            scrollIntoView(newIndex);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const newIndex = selectedIndex > 0 ? selectedIndex - 1 : -1;
            setSelectedIndex(newIndex);
            if (newIndex >= 0) scrollIntoView(newIndex);
        } else if ((e.key === 'Enter') && selectedIndex >= 0) {
            e.preventDefault();
            handleSuggestionClick(namesuggestions[selectedIndex]);
            setIsNameInputFocused(false);
            setSelectedIndex(-1);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (selectedIndex >= 0) {
                handleSuggestionClick(namesuggestions[selectedIndex]);
            }
            setIsNameInputFocused(false);
            setSelectedIndex(-1);
        }
    };

    const scrollIntoView = (index) => {
        if (namesuggestionsRef.current && namesuggestionsRef.current.children[index]) {
            namesuggestionsRef.current.children[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };

    const handleInputChange = (e) => {
        handleChange(e); 
        if (!isNameInputFocused) {
            setIsNameInputFocused(true); 
        }
    };

    useEffect(() => {
        if (!isNameInputFocused) {
            setSelectedIndex(-1);
        }
    }, [isNameInputFocused]);

    useEffect(() => {
        if (formData.firstName.length < 4) {
            setnameSuggestions([]);
          return;
        }
        if (namequery.trim()) {
          const delayDebounceFn = setTimeout(async () => {
            try {
              setnameLoading(true);
              const response = await searchGuest(namequery);
              if (response.data.status) {
                setnameSuggestions(response.data.data);
              }
            } catch (error) {
              console.error("Error fetching suggestions", error);
            } finally {
              setnameLoading(false);
            }
          }, 500);
          return () => clearTimeout(delayDebounceFn);
        }
      }, [namequery]);

    return (
        <div className="relative col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">First Name*</label>
                   <div className="relative">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onFocus={() => setIsNameInputFocused(true)}
                        onBlur={() => setTimeout(() => setIsNameInputFocused(false), 200)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        keydata="first_name"
                        required
                      />
                     
                {nameloading && (
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                        <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                )}
                 {formErrors.firstName && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.firstName}
                        </p>
                      )}
                {/* {formErrors.mobileNumber && (
                    <p className="mt-1 text-sm text-red-600">{formErrors.mobileNumber}</p>
                )} */}
                {namesuggestions.length > 0 && isNameInputFocused && (
                    <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto" ref={namesuggestionsRef} >
                        {namesuggestions.map((data, index) => (
                            <div
                                key={index}
                                onMouseDown={() => handleSuggestionClick(data)}
                                className={`px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 cursor-pointer border-b border-gray-100 last:border-b-0 ${index === selectedIndex ? 'bg-indigo-50' : ''
                                    }`}
                            >
                                {data.MobileNo} - {data.FirstName} {data.LastName||""}
                                {data.otherGuests?.length > 0 ? ` - ${data.otherGuests[0].fullName}` : ""}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NamesearchDropdown;

// ref={dropdownRef}